import type { SidebarCreateAction } from '@affine/core/modules/app-sidebar/views/area-actions/create-actions';

import { OrganizeCreateMenu } from '../sections/organize/create-menu';
import {
  SidebarAreaOptionsMenu,
  type SidebarAreaOptionsMenuProps,
} from './sidebar-area-options-menu';

export function SidebarAreaHeaderActions({
  create,
  options,
}: {
  create?: {
    actions: readonly SidebarCreateAction[];
    testId?: string;
    tooltip: string;
  };
  options?: SidebarAreaOptionsMenuProps;
}) {
  return (
    <>
      {create ? <OrganizeCreateMenu {...create} /> : null}
      {options ? <SidebarAreaOptionsMenu {...options} /> : null}
    </>
  );
}
